import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Link } from '../../Link/Link.es.js';

const TextLink = (props)=>{
    const classes = classNames('cb-text-link', props.size ?? 'base', props.variant, {
        disabled: props.disabled
    }, props.className);
    return jsx(Link, {
        ...props,
        className: classes
    });
};
TextLink.displayName = 'TextLink.Link';

export { TextLink as default };
//# sourceMappingURL=TextLink.Link.es.js.map
